import styled from 'styled-components';
import { screen, spacing } from 'theme';

export const StyledPagination = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacing('xs')};
  margin-top: ${spacing('xl3')};
  margin-bottom: ${spacing('xl')};

  .number {
    @media (max-width: ${screen('mdMax')}) {
      display: none;
    }
  }
`;

export const StyledEllipsis = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${screen('mdMax')}) {
    display: none;
  }
`;
